import { i18n } from "@lingui/core";
import { createFileRoute } from "@tanstack/react-router";

import { AccountLayout } from "@/views/account/layout";

export const Route = createFileRoute("/_authenticated/account")({
  component: AccountLayout,
  loader() {
    return {
      breadcrumbLabel: i18n._("account.breadcrumb"),
    };
  },
});
